<template>
  <span contenteditable="true" @input="update" />
</template>

<script>
export default {
  name: 'Editable',
  props:['content'],
  mounted: function() {
    this.$el.innerText = this.content
  },
  methods: {
    update: function(event) {
      this.$emit('update',event.target.innerText)
    }
  }
}
</script>

<style scoped>
</style>
